export default __webpack_public_path__ + "static/media/banner-bem-estar-campanha.05d529de.png";